import { getAdUnitData } from "./utils/helpers";
import { AdSettingsProps } from "./utils/types";

export default function AdSettings({
  adNames,
  path,
  adTargets = [], // page level ad targets
  slotTargets = [], // slot level ad targets
  pageType,
  isABTestEnabled = false,
}: AdSettingsProps): React.ReactElement {
  const encodedPath =
    typeof path !== undefined ? path.replaceAll("'", "%27") : "";

  // If initial gsChannels is empty string, do not render the ad settings.
  const gsChannels = slotTargets.find(
    (target) => target.key === "gs_channels"
  )?.value;

  if (gsChannels === "") return <></>;

  const adUnits = getAdUnitData(adNames, encodedPath, slotTargets);
  const pageData = {
    pageType: pageType,
    path: encodedPath,
    adUnits: adUnits,
    adTargets: adTargets,
    isABTestEnabled,
  };

  const loaded_dfp_tags = adUnits.reduce((previous, current) => {
    return {
      ...previous,
      [current.type]: {
        adunit: current.pattern,
        slotname: current.id,
        size: Object.keys(current.slotSize)
          .map((key) => {
            const sizes = current.slotSize?.[parseInt(key)];

            return sizes?.toString().replaceAll(",", "x");
          })
          .join(","),
      },
    };
  }, {});

  return (
    <>
      <script
        id="ads-settings"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: `${[
            "window.bt_page_data = " + JSON.stringify(pageData) + ";",
            "var loaded_dfp_tags = '" + JSON.stringify(loaded_dfp_tags) + "';",
          ].join(" ")}(${overlaySEF.toString()})()`,
        }}
      />
    </>
  );
}

// a self executing function injected into the head
const overlaySEF = function () {
  if (typeof window === "undefined") return;

  const hasDfpPreview = window.location.search.includes("dfp_preview");

  if (screen.width >= 768 || hasDfpPreview) {
    setTimeout(function () {
      const myPageOverlay = document.getElementById("MyPageOverlay");
      if (myPageOverlay) myPageOverlay?.classList.remove("overlayWhite");
    }, 4e3);
  }
};
